const spontaneousService = {
    /**
     * Fetches paginated spontaneous applications from the API
     * @param {string} accessToken - The authentication token
     * @param {number} page - The page number to fetch
     * @param {string} apiUrl - Base API URL
     * @returns {Promise<{spontaneous: Array, totalPages: number, currentPage: number}>} The spontaneous applications data and pagination info
     */
    async fetchSpontaneous(accessToken, page = 1, apiUrl) {
      try {
        // if (!accessToken) {
        //   throw new Error('Authentication token is required');
        // }
  
        const response = await fetch(`${apiUrl}authentication/all-spontaneous/?page=${page}`, {
          // headers: {
          //   Authorization: `Bearer ${accessToken}`,
          //   "Content-Type": "application/json",
          // },
        });
  
        // Handle HTTP errors
        if (!response.ok) {
          const errorData = await response.json().catch(() => ({}));
          throw new Error(errorData.message || `Failed to fetch spontaneous applications: ${response.status}`);
        }
  
        const data = await response.json();
        console.log('Data is : ', data);
        
        // The API returns the data as a direct array, so we need to structure it correctly
        return {
          spontaneous: data || [], // Use the entire data array as spontaneous
          totalPages: data.length > 0 ? Math.ceil(data.length / 10) : 1, // Estimate total pages
          currentPage: page
        };
      } catch (error) {
        console.error('Error fetching spontaneous applications:', error);
        throw error;
      }
    }
  };
  
  export default spontaneousService;
  